"use strict";
// Copyright (C) 2017-2026 Smart code 203358507
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_i18next_1 = require("react-i18next");
var Placeholder_less_1 = __importDefault(require("./Placeholder.less"));
var Placeholder = function () {
    var t = (0, react_i18next_1.useTranslation)().t;
    return (react_1.default.createElement("div", { className: Placeholder_less_1.default['placeholder'], role: 'status', "aria-label": t('STREAM_LOADING') },
        react_1.default.createElement("div", { className: Placeholder_less_1.default['channel'], "aria-hidden": 'true' },
            react_1.default.createElement("div", { className: Placeholder_less_1.default['identity'] }),
            react_1.default.createElement("div", { className: Placeholder_less_1.default['title'] }),
            react_1.default.createElement("div", { className: Placeholder_less_1.default['description'] }),
            react_1.default.createElement("div", { className: Placeholder_less_1.default['action'] })),
        react_1.default.createElement("div", { className: Placeholder_less_1.default['schedule'], "aria-hidden": 'true' },
            react_1.default.createElement("div", null),
            react_1.default.createElement("div", null),
            react_1.default.createElement("div", null))));
};
exports.default = Placeholder;
